export const en = {
  'shell.nav.barOrders': 'Orders',
  'shell.nav.barSuppliers': 'Suppliers',
  'enum.purchaseOrderStatus.DRAFT': 'Draft',
  'enum.purchaseOrderStatus.ORDERED': 'Ordered',
  'enum.purchaseOrderStatus.PARTLY_RECEIVED': 'Part received',
  'enum.purchaseOrderStatus.RECEIVED': 'Received',
  'enum.purchaseOrderStatus.CANCELLED': 'Cancelled',

  'purchasing.item': 'Item',
  'purchasing.notes': 'Notes',

  'suppliers.title': 'Suppliers',
  'suppliers.description': 'Who the bar buys from, how to reach them, what they supply and what it last cost.',
  'suppliers.add': 'Add supplier',
  'suppliers.searchPlaceholder': 'Search by name, contact or tax ID',
  'suppliers.anyStatus': 'Active and inactive',
  'suppliers.activeOnly': 'Active only',
  'suppliers.inactiveOnly': 'Inactive only',
  'suppliers.empty': 'No suppliers yet',
  'suppliers.emptyHint': 'Add the companies the bar orders from, then order stock from them.',
  'suppliers.noMatch': 'No suppliers match',
  'suppliers.noMatchHint': 'Try another search or filter.',
  'suppliers.col.supplier': 'Supplier',
  'suppliers.col.items': 'Items',
  'suppliers.col.openOrders': 'Open orders',
  'suppliers.statusActive': 'Active',
  'suppliers.statusInactive': 'Inactive',
  'suppliers.taxId': 'Tax ID',
  'suppliers.contact': 'Contact person',
  'suppliers.terms': 'Payment terms',
  'suppliers.termsDays': '{days} days',
  'suppliers.termsHint': 'Days to pay after a delivery',
  'suppliers.active': 'Active',
  'suppliers.activeHint': 'Switch off to stop ordering; old orders keep the supplier.',
  'suppliers.dialog.addTitle': 'Add supplier',
  'suppliers.dialog.addDescription': 'Once it is saved you can list the items it supplies.',
  'suppliers.dialog.editTitle': 'Supplier',
  'suppliers.form.nameRequired': 'Enter the supplier’s name',
  'suppliers.form.created': 'Supplier added',
  'suppliers.form.saved': 'Supplier saved',
  'suppliers.items.title': 'Items supplied',
  'suppliers.items.hint': 'The last cost comes from the latest delivery and is the starting price of the next order.',
  'suppliers.items.empty': 'No items listed yet.',
  'suppliers.items.lastCost': 'Last cost',
  'suppliers.items.lastCostAt': 'Since',
  'suppliers.items.choose': 'Choose an item',
  'suppliers.items.startCost': 'Starting cost ({currency})',
  'suppliers.items.add': 'Add item',
  'suppliers.items.added': 'Item added',
  'suppliers.items.remove': 'Remove {name}',
  'suppliers.items.removed': 'Item removed',

  'orders.title': 'Orders',
  'orders.description': 'Stock the bar orders from its suppliers. A delivery you check in adds to the shelf at the cost on the invoice.',
  'orders.add': 'New order',
  'orders.back': 'All orders',
  'orders.tab.orders': 'Orders',
  'orders.tab.reorder': 'Reorder',
  'orders.searchPlaceholder': 'Search by order number or supplier',
  'orders.anyStatus': 'Any status',
  'orders.empty': 'No orders yet',
  'orders.emptyHint': 'Start an order for a supplier, or draft one from the items that are running low.',
  'orders.noMatch': 'No orders match',
  'orders.noMatchHint': 'Try another search or status.',
  'orders.col.order': 'Order',
  'orders.col.units': 'Received',
  'orders.col.total': 'Total',
  'orders.col.quantity': 'Ordered',
  'orders.col.received': 'Received',
  'orders.col.unitCost': 'Unit cost',
  'orders.units': '{received} of {ordered}',
  'orders.supplier': 'Supplier',
  'orders.branch': 'Branch',
  'orders.expectedOn': 'Expected on',
  'orders.details': 'Details',
  'orders.createdBy': 'Created by',
  'orders.orderedAt': 'Ordered',
  'orders.completedAt': 'Finished',
  'orders.cancelledAt': 'Cancelled',
  'orders.closedShortNote': 'Closed with some items short',
  'orders.expense': 'Expense',
  'orders.expenseLogged': 'Logged in Bar purchases',
  'orders.lines': 'Items',
  'orders.orderTotal': 'Order total',
  'orders.receivedTotal': 'Received so far',
  'orders.receipts': 'Deliveries',
  'orders.noReceipts': 'Nothing has arrived yet.',
  'orders.unknownPerson': 'Unknown',
  'orders.overDelivery': 'Over-delivery accepted',
  'orders.receiptLine': '{quantity} × {name} at {cost}',
  'orders.receive': 'Receive delivery',
  'orders.place': 'Mark as ordered',
  'orders.placed': 'Order marked as ordered',
  'orders.logExpense': 'Log as expense',
  'orders.pdf': 'PDF ({language})',
  'orders.closeShort': 'Close order',
  'orders.closeShortTitle': 'Close this order?',
  'orders.closeShortDescription': 'What has arrived stays on the shelf. The supplier will not deliver the rest, and the order is finished.',
  'orders.closedShort': 'Order closed',
  'orders.cancel': 'Cancel order',
  'orders.cancelTitle': 'Cancel {number}?',
  'orders.cancelDescription': 'Nothing has arrived for this order. It stays in the list as cancelled.',
  'orders.cancelReason': 'Reason',
  'orders.cancelled': 'Order cancelled',
  'orders.keep': 'Keep order',
  'orders.expenseTitle': 'Log {number} as an expense',
  'orders.expenseDescription': 'One expense of {amount} in Bar purchases, for what arrived.',
  'orders.expenseMethod': 'Paid by',
  'orders.expenseDone': 'Expense logged',
  'orders.form.addTitle': 'New order',
  'orders.form.addDescription': 'It starts as a draft. Check it, send it to the supplier, then mark it as ordered.',
  'orders.form.editTitle': 'Edit {number}',
  'orders.form.supplierRequired': 'Choose a supplier',
  'orders.form.chooseSupplier': 'Choose a supplier',
  'orders.form.lines': 'Items',
  'orders.form.linesHint': 'Quantity and unit cost in {currency}. Leave the cost empty to use the supplier’s last cost.',
  'orders.form.chooseItem': 'Choose an item',
  'orders.form.lastCost': 'Last cost',
  'orders.form.lineItem': 'Item of line {number}',
  'orders.form.lineQuantity': 'Quantity of line {number}',
  'orders.form.lineCost': 'Unit cost of line {number}',
  'orders.form.removeLine': 'Remove line {number}',
  'orders.form.addLine': 'Add item',
  'orders.form.linesRequired': 'Add at least one item with a quantity.',
  'orders.form.linesInvalid': 'Every item needs a whole quantity of at least 1.',
  'orders.form.createDraft': 'Create draft',
  'orders.form.created': 'Draft order created',
  'orders.form.saved': 'Order saved',

  'receive.title': 'Receive {number}',
  'receive.description': 'Count what arrived from {supplier} at {branch}. It is added to the shelf now.',
  'receive.remaining': 'Still to come',
  'receive.ofOrdered': '{remaining} of {ordered}',
  'receive.arrived': 'Arrived',
  'receive.arrivedFor': 'Arrived: {name}',
  'receive.unitCost': 'Unit cost ({currency})',
  'receive.costFor': 'Unit cost: {name}',
  'receive.overTitle': 'More than was ordered',
  'receive.overLine': '{name}: {extra} over',
  'receive.confirmOver': 'The supplier delivered more and I accept it',
  'receive.note': 'Note',
  'receive.submit': 'Add to stock',
  'receive.done': 'Delivery added to stock',

  'reorder.suggestions': 'To order at {branch}',
  'reorder.nothing': 'Nothing is at or below its reorder level.',
  'reorder.noSupplier': 'No supplier yet',
  'reorder.noSupplierHint': 'List these items under a supplier to draft an order for them.',
  'reorder.groupHint': 'At or below the reorder level at {branch}',
  'reorder.draft': 'Draft order',
  'reorder.drafted': 'Draft order created',
  'reorder.onHand': 'On hand',
  'reorder.level': 'Reorder level',
  'reorder.incoming': 'On the way',
  'reorder.suggested': 'Suggested',
  'reorder.quantity': 'Order quantity',
  'reorder.levels': 'Reorder levels at {branch}',
  'reorder.levelsHint': 'An item is suggested when its shelf, with what is already on order, is at or below its level.',
  'reorder.noItems': 'The bar counts no items yet.',
  'reorder.dialogTitle': 'Reorder level: {name}',
  'reorder.dialogDescription': 'For this branch only. Leave the level empty to stop suggesting the item.',
  'reorder.levelHint': 'Suggest at or below',
  'reorder.quantityHint': 'Empty: back to twice the level',
  'reorder.saved': 'Reorder level saved',

  'admin.apiError.SUPPLIER_NAME_TAKEN': 'A supplier with this name already exists.',
  'admin.apiError.SUPPLIER_INACTIVE': 'This supplier is switched off. Turn it on to order from it.',
  'admin.apiError.ITEM_NOT_COUNTED': 'The bar does not count one of these items.',
  'admin.apiError.ITEM_REMOVED': 'An item on this order has been removed from the menu.',
  'admin.apiError.DUPLICATE_LINE': 'Each item can be on the order only once.',
  'admin.apiError.ORDER_CLOSED': 'This order is finished and no longer changes.',
  'admin.apiError.ORDER_EMPTY': 'An order needs at least one item.',
  'admin.apiError.ORDER_NOT_DRAFT': 'Only a draft can be edited or placed.',
  'admin.apiError.ORDER_NOT_CANCELLABLE': 'Only an order nothing has arrived for can be cancelled.',
  'admin.apiError.ORDER_NOT_PARTLY_RECEIVED': 'Only an order that was part received can be closed.',
  'admin.apiError.ORDER_NOT_RECEIVABLE': 'This order is not waiting for a delivery.',
  'admin.apiError.ORDER_NOT_RECEIVED': 'Log the expense once the order is fully received.',
  'admin.apiError.OVER_DELIVERY': 'This is more than was ordered. Confirm the over-delivery to accept it.',
  'admin.apiError.EXPENSE_ALREADY_LOGGED': 'This is already logged as an expense.',
  'admin.apiError.NOTHING_TO_LOG': 'Nothing with a cost was received on this order.',
  'admin.apiError.EXPENSE_CATEGORY_MISSING': 'The Bar purchases expense category does not exist.',
  'admin.apiError.NOTHING_TO_REORDER': 'Nothing from this supplier is at or below its reorder level.',
};

export const ka: Record<keyof typeof en, string> = {
  'shell.nav.barOrders': 'შეკვეთები',
  'shell.nav.barSuppliers': 'მომწოდებლები',
  'enum.purchaseOrderStatus.DRAFT': 'დრაფტი',
  'enum.purchaseOrderStatus.ORDERED': 'შეკვეთა გაგზავნილია',
  'enum.purchaseOrderStatus.PARTLY_RECEIVED': 'ნაწილობრივ მიღებულია',
  'enum.purchaseOrderStatus.RECEIVED': 'მიღებულია',
  'enum.purchaseOrderStatus.CANCELLED': 'გაუქმებულია',

  'purchasing.item': 'პროდუქტი',
  'purchasing.notes': 'შენიშვნები',

  'suppliers.title': 'მომწოდებლები',
  'suppliers.description': 'ვისგან ყიდულობს ბარი პროდუქციას, როგორ დაუკავშირდეთ, რას აწვდიან და რა ფასად მივიღეთ ბოლოს.',
  'suppliers.add': 'მომწოდებლის დამატება',
  'suppliers.searchPlaceholder': 'ძებნა სახელით, საკონტაქტო პირით ან საიდენტიფიკაციო კოდით',
  'suppliers.anyStatus': 'აქტიური და არააქტიური',
  'suppliers.activeOnly': 'მხოლოდ აქტიური',
  'suppliers.inactiveOnly': 'მხოლოდ არააქტიური',
  'suppliers.empty': 'მომწოდებლები ჯერ არ არის',
  'suppliers.emptyHint': 'დაამატეთ კომპანიები, რომლებისგანაც ბარი პროდუქციას იღებს, და შემდეგ მათ შეუკვეთეთ მარაგი.',
  'suppliers.noMatch': 'მომწოდებელი ვერ მოიძებნა',
  'suppliers.noMatchHint': 'სცადეთ სხვა საძიებო სიტყვა ან ფილტრი.',
  'suppliers.col.supplier': 'მომწოდებელი',
  'suppliers.col.items': 'პროდუქტები',
  'suppliers.col.openOrders': 'ღია შეკვეთები',
  'suppliers.statusActive': 'აქტიურია',
  'suppliers.statusInactive': 'არააქტიურია',
  'suppliers.taxId': 'საიდენტიფიკაციო კოდი',
  'suppliers.contact': 'საკონტაქტო პირი',
  'suppliers.terms': 'გადახდის პირობები',
  'suppliers.termsDays': '{days} დღე',
  'suppliers.termsHint': 'დღეები მიწოდების შემდეგ გადასახდელად',
  'suppliers.active': 'აქტიურია',
  'suppliers.activeHint': 'გამორთვის შემთხვევაში მას ვეღარ შეუკვეთავთ; ძველ შეკვეთებში ის რჩება.',
  'suppliers.dialog.addTitle': 'მომწოდებლის დამატება',
  'suppliers.dialog.addDescription': 'შენახვის შემდეგ შეძლებთ მის მიერ მოწოდებული პროდუქციის მითითებას.',
  'suppliers.dialog.editTitle': 'მომწოდებელი',
  'suppliers.form.nameRequired': 'მიუთითეთ მომწოდებლის სახელი',
  'suppliers.form.created': 'მომწოდებელი დაემატა',
  'suppliers.form.saved': 'მომწოდებელი შენახულია',
  'suppliers.items.title': 'მოწოდებული პროდუქცია',
  'suppliers.items.hint': 'ბოლო ფასი ბოლო მიწოდებიდან მოდის და შემდეგი შეკვეთის საწყისი ფასია.',
  'suppliers.items.empty': 'პროდუქცია ჯერ არ არის მითითებული.',
  'suppliers.items.lastCost': 'ბოლო ფასი',
  'suppliers.items.lastCostAt': 'თარიღი',
  'suppliers.items.choose': 'აირჩიეთ პროდუქტი',
  'suppliers.items.startCost': 'საწყისი ფასი ({currency})',
  'suppliers.items.add': 'პროდუქტის დამატება',
  'suppliers.items.added': 'პროდუქტი დაემატა',
  'suppliers.items.remove': 'წაშალეთ: {name}',
  'suppliers.items.removed': 'პროდუქტი ამოღებულია',

  'orders.title': 'შეკვეთები',
  'orders.description': 'მარაგი, რომელსაც ბარი მომწოდებლებს უკვეთავს. მიღებული მიწოდება ემატება თაროს ინვოისზე მითითებული ფასით.',
  'orders.add': 'ახალი შეკვეთა',
  'orders.back': 'ყველა შეკვეთა',
  'orders.tab.orders': 'შეკვეთები',
  'orders.tab.reorder': 'ხელახლა შეკვეთა',
  'orders.searchPlaceholder': 'ძებნა შეკვეთის ნომრით ან მომწოდებლით',
  'orders.anyStatus': 'ნებისმიერი სტატუსი',
  'orders.empty': 'შეკვეთები ჯერ არ არის',
  'orders.emptyHint': 'შექმენით შეკვეთა მომწოდებლისთვის ან გააკეთეთ დრაფტი იმ პროდუქტებისგან, რომლებიც ილევა.',
  'orders.noMatch': 'შეკვეთა ვერ მოიძებნა',
  'orders.noMatchHint': 'სცადეთ სხვა საძიებო სიტყვა ან სტატუსი.',
  'orders.col.order': 'შეკვეთა',
  'orders.col.units': 'მიღებული',
  'orders.col.total': 'ჯამი',
  'orders.col.quantity': 'შეკვეთილი',
  'orders.col.received': 'მიღებული',
  'orders.col.unitCost': 'ერთეულის ფასი',
  'orders.units': '{received} / {ordered}',
  'orders.supplier': 'მომწოდებელი',
  'orders.branch': 'ფილიალი',
  'orders.expectedOn': 'მოსალოდნელი მიწოდება',
  'orders.details': 'დეტალები',
  'orders.createdBy': 'შეადგინა',
  'orders.orderedAt': 'გაგზავნის დრო',
  'orders.completedAt': 'დასრულდა',
  'orders.cancelledAt': 'გაუქმდა',
  'orders.closedShortNote': 'დაიხურა ნაკლებობით',
  'orders.expense': 'ხარჯი',
  'orders.expenseLogged': 'აღრიცხულია ბარის შესყიდვებში',
  'orders.lines': 'პროდუქცია',
  'orders.orderTotal': 'შეკვეთის ჯამი',
  'orders.receivedTotal': 'ჯერჯერობით მიღებულია',
  'orders.receipts': 'მიწოდებები',
  'orders.noReceipts': 'ჯერ არაფერი მიღებულა.',
  'orders.unknownPerson': 'უცნობი',
  'orders.overDelivery': 'ზედმეტი მიწოდება მიღებულია',
  'orders.receiptLine': '{quantity} × {name}, ფასი: {cost}',
  'orders.receive': 'მიწოდების მიღება',
  'orders.place': 'შეკვეთილად მონიშვნა',
  'orders.placed': 'შეკვეთა მონიშნულია გაგზავნილად',
  'orders.logExpense': 'ხარჯად აღრიცხვა',
  'orders.pdf': 'PDF ({language})',
  'orders.closeShort': 'შეკვეთის დახურვა',
  'orders.closeShortTitle': 'დაიხუროს ეს შეკვეთა?',
  'orders.closeShortDescription': 'რაც უკვე მიღებულია, თაროზე რჩება. მომწოდებელი დანარჩენს აღარ მოიტანს და შეკვეთა დასრულდება.',
  'orders.closedShort': 'შეკვეთა დაიხურა',
  'orders.cancel': 'შეკვეთის გაუქმება',
  'orders.cancelTitle': 'გაუქმდეს {number}?',
  'orders.cancelDescription': 'ამ შეკვეთაზე არაფერი მიღებულა. ის სიაში გაუქმებულად დარჩება.',
  'orders.cancelReason': 'მიზეზი',
  'orders.cancelled': 'შეკვეთა გაუქმდა',
  'orders.keep': 'შეკვეთის დატოვება',
  'orders.expenseTitle': '{number} ხარჯად აღრიცხვა',
  'orders.expenseDescription': 'ერთი ხარჯი {amount} ოდენობით ბარის შესყიდვების კატეგორიაში, იმის მიხედვით, რაც მიღებულია.',
  'orders.expenseMethod': 'გადახდის მეთოდი',
  'orders.expenseDone': 'ხარჯი აღირიცხა',
  'orders.form.addTitle': 'ახალი შეკვეთა',
  'orders.form.addDescription': 'ის დრაფტად იწყება. გადაამოწმეთ, გაუგზავნეთ მომწოდებელს და მონიშნეთ შეკვეთილად.',
  'orders.form.editTitle': '{number} რედაქტირება',
  'orders.form.supplierRequired': 'აირჩიეთ მომწოდებელი',
  'orders.form.chooseSupplier': 'აირჩიეთ მომწოდებელი',
  'orders.form.lines': 'პროდუქცია',
  'orders.form.linesHint': 'რაოდენობა და ერთეულის ფასი ({currency}). ფასი თუ ცარიელია, გამოიყენება მომწოდებლის ბოლო ფასი.',
  'orders.form.chooseItem': 'აირჩიეთ პროდუქტი',
  'orders.form.lastCost': 'ბოლო ფასი',
  'orders.form.lineItem': 'პროდუქტი, სტრიქონი {number}',
  'orders.form.lineQuantity': 'რაოდენობა, სტრიქონი {number}',
  'orders.form.lineCost': 'ერთეულის ფასი, სტრიქონი {number}',
  'orders.form.removeLine': 'სტრიქონის {number} წაშლა',
  'orders.form.addLine': 'პროდუქტის დამატება',
  'orders.form.linesRequired': 'დაამატეთ ერთი პროდუქტი მაინც რაოდენობით.',
  'orders.form.linesInvalid': 'ყველა პროდუქტს სჭირდება მთელი რაოდენობა, არანაკლებ 1.',
  'orders.form.createDraft': 'დრაფტის შექმნა',
  'orders.form.created': 'დრაფტი შეიქმნა',
  'orders.form.saved': 'შეკვეთა შენახულია',

  'receive.title': '{number} მიღება',
  'receive.description': 'დათვალეთ, რა მოიტანა {supplier}-მა ფილიალში „{branch}“. ის ახლავე ემატება თაროს.',
  'receive.remaining': 'კიდევ მისაღები',
  'receive.ofOrdered': '{remaining} / {ordered}',
  'receive.arrived': 'მოვიდა',
  'receive.arrivedFor': 'მოვიდა: {name}',
  'receive.unitCost': 'ერთეულის ფასი ({currency})',
  'receive.costFor': 'ერთეულის ფასი: {name}',
  'receive.overTitle': 'შეკვეთილზე მეტია',
  'receive.overLine': '{name}: {extra}-ით მეტი',
  'receive.confirmOver': 'მომწოდებელმა მეტი მოიტანა და ვიღებ',
  'receive.note': 'შენიშვნა',
  'receive.submit': 'მარაგში დამატება',
  'receive.done': 'მიწოდება დაემატა მარაგს',

  'reorder.suggestions': 'შესაკვეთი: {branch}',
  'reorder.nothing': 'არცერთი პროდუქტი არ არის განმეორებითი შეკვეთის დონეზე ან უფრო დაბლა.',
  'reorder.noSupplier': 'მომწოდებელი ჯერ არ არის',
  'reorder.noSupplierHint': 'მიუთითეთ ეს პროდუქცია რომელიმე მომწოდებელთან, რომ მათთვის დრაფტი შეიქმნას.',
  'reorder.groupHint': 'განმეორებითი შეკვეთის დონეზე ან უფრო დაბლა ფილიალში „{branch}“',
  'reorder.draft': 'დრაფტის შექმნა',
  'reorder.drafted': 'დრაფტი შეიქმნა',
  'reorder.onHand': 'თაროზე',
  'reorder.level': 'შეკვეთის დონე',
  'reorder.incoming': 'გზაშია',
  'reorder.suggested': 'შემოთავაზებული',
  'reorder.quantity': 'შესაკვეთი რაოდენობა',
  'reorder.levels': 'შეკვეთის დონეები: {branch}',
  'reorder.levelsHint': 'პროდუქტი შემოთავაზებულია, როცა თარო უკვე შეკვეთილთან ერთად თავის დონეზე ან უფრო დაბლაა.',
  'reorder.noItems': 'ბარი ჯერ არცერთ პროდუქტს არ ითვლის.',
  'reorder.dialogTitle': 'შეკვეთის დონე: {name}',
  'reorder.dialogDescription': 'მხოლოდ ამ ფილიალისთვის. დონის ცარიელად დატოვებით პროდუქტი აღარ შემოგთავაზდებათ.',
  'reorder.levelHint': 'შემოთავაზება ამ დონეზე ან დაბლა',
  'reorder.quantityHint': 'ცარიელი: დონის ორმაგამდე',
  'reorder.saved': 'შეკვეთის დონე შენახულია',

  'admin.apiError.SUPPLIER_NAME_TAKEN': 'ამ სახელით მომწოდებელი უკვე არსებობს.',
  'admin.apiError.SUPPLIER_INACTIVE': 'ეს მომწოდებელი გამორთულია. შეკვეთისთვის ჩართეთ.',
  'admin.apiError.ITEM_NOT_COUNTED': 'ბარი ამ პროდუქტებიდან ერთს არ ითვლის.',
  'admin.apiError.ITEM_REMOVED': 'ამ შეკვეთის ერთი პროდუქტი მენიუდან ამოღებულია.',
  'admin.apiError.DUPLICATE_LINE': 'თითოეული პროდუქტი შეკვეთაში მხოლოდ ერთხელ შეიძლება იყოს.',
  'admin.apiError.ORDER_CLOSED': 'ეს შეკვეთა დასრულებულია და აღარ იცვლება.',
  'admin.apiError.ORDER_EMPTY': 'შეკვეთაში ერთი პროდუქტი მაინც უნდა იყოს.',
  'admin.apiError.ORDER_NOT_DRAFT': 'მხოლოდ დრაფტის შეცვლა ან გაგზავნაა შესაძლებელი.',
  'admin.apiError.ORDER_NOT_CANCELLABLE': 'გაუქმდება მხოლოდ შეკვეთა, რომელზეც არაფერი მიღებულა.',
  'admin.apiError.ORDER_NOT_PARTLY_RECEIVED': 'დაიხურება მხოლოდ ნაწილობრივ მიღებული შეკვეთა.',
  'admin.apiError.ORDER_NOT_RECEIVABLE': 'ეს შეკვეთა მიწოდებას არ ელოდება.',
  'admin.apiError.ORDER_NOT_RECEIVED': 'ხარჯი აღრიცხეთ შეკვეთის სრულად მიღების შემდეგ.',
  'admin.apiError.OVER_DELIVERY': 'ეს შეკვეთილზე მეტია. ზედმეტი მიწოდების მისაღებად დაადასტურეთ.',
  'admin.apiError.EXPENSE_ALREADY_LOGGED': 'ეს უკვე აღრიცხულია ხარჯად.',
  'admin.apiError.NOTHING_TO_LOG': 'ამ შეკვეთაზე ფასიანი არაფერი მიღებულა.',
  'admin.apiError.EXPENSE_CATEGORY_MISSING': 'ხარჯის კატეგორია „ბარის შესყიდვები“ არ არსებობს.',
  'admin.apiError.NOTHING_TO_REORDER': 'ამ მომწოდებლის არცერთი პროდუქტი არ არის შეკვეთის დონეზე ან უფრო დაბლა.',
};
